import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class ShippingTermsRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    shippingTermsId: number;

    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    shippingTermsName: string;
    
    @ApiProperty()
    @IsOptional()
    updatedUser: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag: number;

    @ApiProperty()
    isActive: boolean;
}